import React from 'react';
import { Form, Field } from 'react-final-form';
import MakeAsyncFunction from 'react-redux-promise-listener';
import InputField from 'src/components/InputField';
import SelectField from 'src/components/SelectField';
import { promiseListener } from 'src/store';
import validations from './validations';

const FormBody = ({ handleSubmit }) => (
    <form onSubmit={handleSubmit}>                        
        <div className="pl-lg-4">
            <div className="row">
                <div className="col-12 col-md-6">
                    <Field
                        name="title"
                        type="text"
                        className="form-control"
                        label="Modelo PinPad"
                        component={InputField}
                    />
                </div>
                <div className="col-12 col-md-6">
                    <Field
                        name="phone"
                        type="text"
                        className="form-control"
                        label="Número de Série"
                        component={InputField}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-4">
                    <Field
                        name="address.zipCode"
                        type="text"
                        className="form-control"
                        label="CEP"
                        component={InputField}
                    />
                </div>
                <div className="col-12 col-md-8">
                    <Field
                        name="address.address"
                        type="text"
                        className="form-control"
                        label="Logradouro"
                        component={InputField}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-4">
                    <Field
                        name="address.neighborhood"
                        type="text"
                        className="form-control"
                        label="Bairro"
                        component={InputField}
                    />
                </div>
                <div className="col-12 col-md-4">
                    <Field
                        name="address.city"
                        type="text"
                        className="form-control"
                        label="Cidade"
                        component={InputField}
                    />
                </div>
                <div className="col-12 col-md-2">
                    <Field
                        name="address.state"
                        type="text"
                        className="form-control"
                        label="UF"
                        component={SelectField}
                    />
                </div>
                <div className="col-12 col-md-2">
                    <Field
                        name="address.number"
                        type="text"
                        className="form-control"
                        label="Número"
                        component={InputField}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <Field
                        name="address.complement"
                        type="text"
                        className="form-control"
                        label="Complemento"
                        component={InputField}
                    />
                </div>
            </div>
            <div className="form-group">
                <label for="example-text-input" className="form-control-label">Ativar</label>
                <div className="custom-control custom-checkbox mb-3">
                    <input className="custom-control-input" id="customCheck1" type="checkbox" />
                    <label className="custom-control-label" for="customCheck1">Ativado</label>
                </div>  
            </div>
        </div>
        <div className="text-center">
            <button type="submit" className="btn btn-success mt-4">Salvar</button>
        </div>
    </form>
);

const EstablishmentForm = ({ actions }) => (
    <MakeAsyncFunction
        listener={promiseListener}
        {...actions}
        >{submit => (
            <Form
                onSubmit={submit}
                // validate={validations}
                render={(props) => ( <FormBody {...props} />)}
            />
        )}
    </MakeAsyncFunction>
);

export default EstablishmentForm;


// WEBPACK FOOTER //
// ./src/components/Pages/Terminals/Management/Form.js